import { useMemo } from "react";
import { setData } from "../../utils/localstorage";
import { DEVICE } from "../../helper/const";

export default function CheckScreen() {
  useMemo(() => {
    const ua = navigator.userAgent || "";

    const isMobileUA = /iPhone|iPad|iPod|Android/i.test(ua);
    const isMobileCH = navigator.userAgentData?.mobile;
    const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    const isSmallScreen = window.innerWidth <= 768;

    const isMobile = isMobileCH ?? (isMobileUA || (isTouch && isSmallScreen));

    const isWebView =
      /wv/.test(ua) ||
      !!window.ReactNativeWebView ||
      window.navigator.standalone === false;

    const app = /Zalo/i.test(ua)
      ? "zalo"
      : /FBAN|FBAV/i.test(ua)
        ? "facebook"
        : /Instagram/i.test(ua)
          ? "instagram"
          : /TikTok/i.test(ua)
            ? "tiktok"
            : "browser";

    const isPWA =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    setData(DEVICE, {
      isMobile,
      isWebView,
      isPWA,
      app,
    });

    return {
      isMobile,
      isWebView,
      isPWA,
      app,
    };
  }, []);
  return null;
}
